export default axios => ({
    getList() {
        return axios.get(`/mobile-devices`);
    },
    getGraph(params) {
        return axios.get(`/mobile-devices/graph`, params);
    }
})